import { imgixUrl } from '@uswitch/comms-ui.image'
import { Fragment } from 'react'

import styles from './styles.module.css'

const EXPERT_IMG_SIZE = 88

const ExpertPickWrapper = ({ title = 'Our expert says', author, productCallout, children, isInExperiment }) => {
  if (!productCallout || !isInExperiment) return <Fragment>{children}</Fragment>

  return (
    <div className={styles.container}>
      <div className={styles.authorInfo}>
        <img
          src={`${imgixUrl(author.image.url)}?w=${EXPERT_IMG_SIZE}&h=${EXPERT_IMG_SIZE}`}
          alt={author.image.description}
          className={styles.authorImage}
        />

        <div className={styles.authorDetails}>
          <h6 className={styles.expertPickTitle}>{title}</h6>

          <a href={author.url} target='_blank' rel='noreferrer'>
            {`${author.name}, ${author.role}`}
          </a>
        </div>
      </div>

      <p className={styles.productDescription}>{productCallout}</p>

      {children}
    </div>
  )
}

export default ExpertPickWrapper
